import { Injectable, Inject, Optional } from '@angular/core';
import {
  PriceConfigService,
  GungCurrencyPipe,
  AuthService,
  CartService,
  PriceService,
  ProductService,
  GungAnonymousConfigService,
} from 'gung-standard';
import { TranslateService } from '@ngx-translate/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { first } from 'rxjs';
import { GungLanguageConfigService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class ColmecPriceConfigService extends PriceConfigService {
  public hidePrice: Subject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected currencyPipe: GungCurrencyPipe,
    protected cartService: CartService,
    protected priceService: PriceService,
    protected productService: ProductService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected translateService: TranslateService,
    protected gungLanguageConfigService: GungLanguageConfigService
  ) {
    super(currencyPipe, cartService, priceService, productService, authService, gungAnonymousConfigService, translateService, gungLanguageConfigService);
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => this.hidePrice.next(roles.indexOf('NOPRICE') >= 0 || roles.indexOf('VIEW') >= 0));
  }
}
